export default "__VITE_ASSET__BWbL2ZRN__"